<template>
  <div class="shopCart">
    <div class="header">
      <div class="header-left">{{ $t('購物車') }}<span v-if="standardLength">({{ standardLength }})</span></div>
      <div class="header-right" v-if="cartList.length" @click="handleOnManage">{{ !isAllDelete ? $t('管理') : $t('完成') }}
      </div>
    </div>
    <!-- 换购 -->
    <div class="replacement" v-if="objData.nscExchangeProducts && objData.nscExchangeProducts.length > 0">
      <div class="replacement-btn">{{ $t('换購') }}</div>
      <div style="flex:1;">
        <template v-if="objData.nscExchangeProducts[0].type == '0'">
          <!-- 满足换购条件 -->
          <div v-if="canExchangeprice >= objData.nscExchangeProducts[0].number" class="replacement-content">
            {{
              langEnv ==
                3 ?
                `選購已滿${formatNumber(objData.nscExchangeProducts[0].number)}，可享優惠價換購${objData.nscExchangeProducts[0].exchangeNumber}件商品`
                : `Order
            reach ${formatNumber(objData.nscExchangeProducts[0].number)}, add money to redeem
            ${objData.nscExchangeProducts[0].exchangeNumber} item`
            }}
          </div>
          <!-- 不满足换购条件 -->
          <div v-if="canExchangeprice < objData.nscExchangeProducts[0].number" class="replacement-content">

            {{ objData.exchangeText }}{{ langEnv == 3 ? `仲差${formatNumber(objData.nscExchangeProducts[0].number -
              canExchangeprice)}` : ` (Only ${formatNumber(objData.nscExchangeProducts[0].number - canExchangeprice)}
            away)`
            }}
          </div>
        </template>
        <!-- 件 -->
        <template v-if="objData.nscExchangeProducts[0].type == '1'">
          <!-- 满足换购条件 -->
          <div v-if="mainQuantitySum >= objData.nscExchangeProducts[0].number" class="replacement-content">
            {{
              langEnv ==
                3 ?
                `選購已滿${objData.nscExchangeProducts[0].number}件，可享優惠價換購${objData.nscExchangeProducts[0].exchangeNumber}件商品`
                : `Order reach ${objData.nscExchangeProducts[0].number}pieces, add money to redeem
            ${objData.nscExchangeProducts[0].exchangeNumber} item`
            }}
          </div>
          <!-- 不满足换购条件 -->
          <div v-if="mainQuantitySum < objData.nscExchangeProducts[0].number" class="replacement-content">
            {{ objData.exchangeText }}{{ langEnv == 3 ? `仲差${objData.nscExchangeProducts[0].number - mainQuantitySum}件`
              : `(Only ${objData.nscExchangeProducts[0].number - mainQuantitySum} items away)`
            }}
          </div>
        </template>
      </div>
      <div class="replacement-right" @click="goExchange('0')"
        v-if="objData.nscExchangeProducts[0].type === '0' && canExchangeprice >= objData.nscExchangeProducts[0].number">
        {{ $t('去換購') }} ></div>
      <div class="replacement-right" @click="goExchange('0')"
        v-else-if="objData.nscExchangeProducts[0].type === '1' && mainQuantitySum >= objData.nscExchangeProducts[0].number">
        {{ $t('去換購') }} ></div>
      <div class="replacement-right-other" @click="goExchange('0')" v-else>{{ $t('查看換購') }} ></div>
    </div>
    <div class="main" v-if="cartList.length">
      <goodItems v-for="(item,index) in cartList" :key="index" :objData="item" @Remove="handeRemoveAmount"
        @Add="handeAddAmount" @getIsAmount="handlegetIsAmount" @onSelect="handleOnselect" @onDelete="handleonDelete"
        @goExchange="(data) => goExchange('1',data)" @onSingleDelete="handleonSingleDelete" />
    </div>
    <div v-else class="empty">
      <img src="@/assets/image/emptyCart.png">
      <div class="title">{{ $t('購物車暫無商品') }}</div>
      <div class="txt">{{ $t('快去挑選自己喜歡的商品吧') }}~</div>
      <div class="empty-btn" @click="handlegoHome">{{ $t('去逛逛') }}</div>
    </div>
    <div class="footer">
      <!-- <div class="shop-coudan" v-if="tips && tips.makeUpType == 2 && CoudanObj && CoudanObj.couponId"> -->
      <div class="shop-coudan" v-if="tips && tips.makeUpType == 2 && CoudanObj && CoudanObj.couponId">
        <div class="shop-coudan-left" v-if="langEnv == 3">
          <div class="tags">滿{{ CoudanObj.metPrice }}減{{ CoudanObj.price }}</div>
          <div class="tigs">滿{{ CoudanObj.metPrice }}減{{ CoudanObj.price }}，還差<span>{{
            formatNumber(CoudanObj.metPrice - Totalprice) }}</span></div>
        </div>
        <div class="shop-coudan-left" v-else>
          <div class="EnTigs">Purchase to {{ formatNumber(CoudanObj.metPrice) }} free {{
            formatNumber(CoudanObj.price) }},Only<span>{{
              formatNumber(CoudanObj.metPrice - Totalprice) }}</span></div>
        </div>
        <div class="shop-coudan-right" @click="handlegoHome">{{ $t('去凑单') }} <van-icon name="arrow" /></div>
      </div>
      <div class="footer-bottom">
        <div class="footer-left">
          <div class="radio">
            <img src="@/assets/icons/did_select.png" v-if="!Allchecked" @click="handleOnAllchecked(true)">
            <img v-else src="@/assets/icons/green_select.png" @click="handleOnAllchecked(false)">
          </div>
          <div class="allSelect">{{ $t('全选') }}</div>
        </div>
        <div class="footer-right" v-if="!isAllDelete">
          <divc class="fee">
            <div class="total">{{ $t('總計') }}：<span>{{ formatNumber(Totalprice) }}</span></div>
            <div class="freight">{{ $t('不含運費') }}</div>
          </divc>
          <div class="settlement" @click="handleSettlement">{{ $t('去結算') }}</div>
        </div>
        <div v-else class="delete-btn" @click="handlebatchDel"> {{ $t('删除') }}</div>
      </div>
    </div>
    <promptDialog ref="promptDialogRef" :confirmText="confirmText" :content="content" @success="handleSuccess" />
    <promptDialog ref="SingleDeleteRef" :confirmText="confirmText" :content="content" @success="handleSingleSuccess" />
    <promptDialog ref="promptDialogRef1" :confirmText="confirmText1" :content="message"
      @success="handleGoauthentication" />
    <tabbar></tabbar>
  </div>
</template>
<script>
import tabbar from "@/components/tabbar/index"
import Mixins from "@/utils/mixins"
import { getShoppingCartList2, deleteShoppingCart2, changeShoppingCart } from "@/api/shopCart"
import { getProductcreateTempOrder } from "@/api/productdetails"
import { deleteShoppingCartExchange } from "@/api/exchangePurchase.js"
import goodItems from "./components/good-items.vue"
import promptDialog from "@/components/promptDialog/index.vue"
import { mapState } from "vuex"
export default {
  name: "shopCart",
  mixins: [Mixins],
  components: {
    promptDialog,
    goodItems,
    tabbar
  },
  data () {
    return {
      confirmText: this.$t('刪除'),
      confirmText1: this.$t('去認證'),
      content: this.$t('確認刪除？'),
      message: '',
      langEnv: null,
      objData: {},
      goodsList: [],
      standardLength: null,
      Totalprice: 0,
      isAllDelete: false,
      delList: [],
      userCoupon: [],
      tips: {},
      CoudanObj: {},
      canExchangeprice: 0,
      mainQuantitySum: 0,
      SingleObj: {}
    }
  },
  mounted () {
    this.getData()
    this.langEnv = window.localStorage.getItem("langEnv") || 2
  },
  computed: {
    ...mapState("shopCart", ["cartList"]),
    Allchecked () {
      if (this.cartList.length) {
        const blom = this.cartList.every(item => item.checked || item.stock === 0 || item.amount > item.stock)
        this.handleGetCoudan()
        return blom
      } else {
        return false
      }

    },
  },
  methods: {
    // 换购
    goExchange (num, item) {
      if (num === "0") {//订单换购 
        this.$router.push({ path: '/exchangeGoods', query: { 'type': num, 'exchangeId': this.objData.exchangeId, 'hasPriceAll': this.canExchangeprice, 'hasAmountAll': this.mainQuantitySum } })
      } else if (num === "1") {//主商品换购
        this.$router.push({ path: '/exchangeGoods', query: { 'type': num, 'exchangeId': this.objData.exchangeId, 'singleItem': JSON.stringify(item) } })
      }
    },
    handleGoauthentication () {
      this.$router.push('/infoPage')
    },
    // 获取最新的凑单情况
    handleGetCoudan () {
      const data = this.cartList.filter(item => item.checked)
      if (!data.length) {
        this.CoudanObj = {}
        return
      }
      let arr = this.userCoupon.sort((a, b) => {
        if (b.metPrice != a.metPrice) {
          return a.metPrice - b.metPrice
        } else {
          return b.price - a.price
        }
      })

      this.CoudanObj = arr.find((item) => item.metPrice > this.Totalprice && item.isAllUse)

    },
    handlegoHome () {
      this.$router.replace("/home")
    },
    async getData () {
      const res = await getShoppingCartList2({ showSelected: false })
      if (res.resultID === 1200) {
        this.objData = res.data
        this.goodsList = res.data.list.map(item => item.goods).flat(1).map(it => {
          return {
            ...it,
            checked: !(it.amount > it.stock)
            // checked: this.cartList.find(items => items.searchProductId === it.searchProductId)?.checked
          }
        })
        this.userCoupon = res.data?.userCoupon
        this.tips = res.data?.tips
        this.$store.dispatch("shopCart/setgoodsList", this.goodsList)
        await this.getLength()
      }
    },
    async handeRemoveAmount (goods) {
      // 只修改被点击的那一条商品
      goods.amount -= 1
      this.getIsAmount(goods, "1")
      this.getLength()
      // 计算同一个商品在购物车列表中的amount总和
      const itemList = this.cartList.filter(obj => obj.searchProductId === goods.searchProductId)
      const count = itemList.reduce((pre, curr) => pre + curr.amount, 0)
      await changeShoppingCart({ count, searchProductId: goods.searchProductId })
      // 更新页面数据
      await this.getData()
    },
    async handeAddAmount (goods) {
      // 只修改被点击的那一条商品
      goods.amount += 1
      this.getIsAmount(goods)
      this.getLength()
      // 计算同一个商品在购物车列表中的amount总和
      const itemList = this.cartList.filter(obj => obj.searchProductId === goods.searchProductId)
      const count = itemList.reduce((pre, curr) => pre + curr.amount, 0)
      await changeShoppingCart({ count, searchProductId: goods.searchProductId })
      // 更新页面数据
      await this.getData()
    },
    async handlegetIsAmount (data) {
      // 只修改被点击的那一条商品
      this.getIsAmount(data)
      this.getLength()
      // 计算同一个商品在购物车列表中的amount总和
      const itemList = this.cartList.filter(obj => obj.searchProductId === data.searchProductId)
      const count = itemList.reduce((pre, curr) => pre + curr.amount, 0)
      await changeShoppingCart({ count, searchProductId: data.searchProductId })
      // 更新页面数据
      await this.getData()
    },
    // 数量判断
    getIsAmount (item, type) {
      if (item.amount % item.sellPartCount != 0) {
        if (type == "1") {
          item.amount -= item.sellPartCount / 2
          item.amount =
            item.sellPartCount * Math.floor(item.amount / item.sellPartCount)
        } else {
          item.amount += item.sellPartCount
          item.amount =
            item.sellPartCount * Math.floor(item.amount / item.sellPartCount)
        }
      }
      // 计算同一个商品在购物车列表中的amount总和
      const itemList = this.cartList.filter(obj => obj.searchProductId === item.searchProductId)
      const totalAmount = itemList.reduce((pre, curr) => pre + curr.amount, 0)
      if (totalAmount > item.stock && item.isBuyLimited) {
        // 超出库存，将当前条目的amount调整为 stock - 其他条目的amount之和
        const otherAmount = itemList.filter(obj => obj !== item).reduce((pre, curr) => pre + curr.amount, 0)
        item.amount = Math.max(item.sellPartCount, item.stock - otherAmount)
        return this.$toast(`${this.$t('限購')}${item.stock}${item.unit}`)
      } else if (totalAmount > item.stock) {
        const otherAmount = itemList.filter(obj => obj !== item).reduce((pre, curr) => pre + curr.amount, 0)
        item.amount = Math.max(item.sellPartCount, item.stock - otherAmount)
        return this.$toast(this.$t('庫存不足'))
      }
    },
    // 获取已选长度
    getLength () {
      // 购物车所有商品的数量
      this.standardLength = this.cartList.reduce(
        (prve, next) => Number(prve) + Number(next.amount),
        0
      )
      this.$store.dispatch("shopCart/setCount", this.standardLength)
      // 选中的商品合计
      this.Totalprice = this.cartList.filter(item => item.checked).reduce((prve, next) => {
        // let price = Number(next.amount * next.unitPrice)
        let price = Number(next.amount * next.displayunitPrice)
        if (next?.changeProduct.length) {
          price += next.changeProduct?.reduce((sum, to) => {
            // return sum + Number(to.amount * to.unitPrice)
            return sum + Number(to.amount * to.displayunitPrice)
          }, 0)
        }
        return Number(prve) + price
      },
        0
      )
      if (this.objData.nscExchangeProducts[0]?.type == '0') {
        this.canExchangeprice = this.cartList.filter(item => item.checked && item.canExchange && item.tagtype !== '2').reduce((prve, next) => {
          // const price = Number(next.amount * next.unitPrice)
          const price = Number(next.amount * next.displayunitPrice)
          return Number(prve) + price
        },
          0
        )
      }
      if (this.objData.nscExchangeProducts[0]?.type == '1') {
        this.mainQuantitySum = this.cartList.filter(item => item.checked && item.canExchange && item.tagtype !== '2').reduce((prve, next) => {
          const price = Number(next.amount)
          return Number(prve) + price
        },
          0
        )
      }
    },
    handleOnselect (data) {
      // 只切换被点击的那一条商品的勾选状态
      data.checked = !data.checked
      this.getLength()
      this.$store.dispatch("shopCart/setgoodsList", this.cartList)
    },
    async handleSuccess () {
      // 统计每个商品在购物车中的数量
      const productIdCountMap = {};
      this.cartList.forEach(item => {
        productIdCountMap[item.searchProductId] = (productIdCountMap[item.searchProductId] || 0) + 1;
      });
      
      // 统计每个商品在删除列表中的数量
      const delProductIdCountMap = {};
      this.delList.forEach(item => {
        delProductIdCountMap[item.searchProductId] = (delProductIdCountMap[item.searchProductId] || 0) + 1;
      });
      
      // 分类处理：需要删除的ID列表 和 需要更新的列表
      const deleteIds = [];
      const updateList = [];
      
      this.delList.forEach(item => {
        const cartCount = productIdCountMap[item.searchProductId] || 0;
        const delCount = delProductIdCountMap[item.searchProductId] || 0;
        
        // 如果购物车中只有一条，直接走删除接口
        if (cartCount === 1) {
          if (!deleteIds.includes(item.searchProductId)) {
            deleteIds.push(item.searchProductId);
          }
        }
        // 如果购物车中有两条且都在删除列表中，去重后只传一个ID
        else if (cartCount === 2 && delCount === 2) {
          if (!deleteIds.includes(item.searchProductId)) {
            deleteIds.push(item.searchProductId);
          }
        } else {
          // 否则调用更新购物车接口（购物车中有两条相同数据但只删除一条）
          if (!updateList.find(u => u.searchProductId === item.searchProductId)) {
            // 数量取另一条（未被删除的）数据的 amount
            let count = item.amount
            // 找到未被删除的那条数据
            const remainingItem = this.cartList.find(i =>
              i.searchProductId === item.searchProductId &&
              !this.delList.some(d => d === i)
            );
            if (remainingItem) {
              count = remainingItem.amount;
            }
            updateList.push({
              searchProductId: item.searchProductId,
              count: count
            });
          }
        }
      });
      
      // 执行删除操作
      if (deleteIds.length > 0) {
        const res = await deleteShoppingCart2({
          goods: deleteIds.map(id => ({ id })),
          isCollect: true
        });
        if (res.resultID !== 1200) {
          return;
        }
      }
      
      // 执行更新操作
      for (const item of updateList) {
        await changeShoppingCart({
          count: item.count,
          searchProductId: item.searchProductId
        });
      }
      
      this.$toast(this.$t('操作成功'))
      this.getData()
    },
    async handleonDelete (goods) {
      // 只删除被点击的那一条商品
      this.delList = [goods]
      await this.handleDelete(this.delList)
    },
    // 单品删除
    handleonSingleDelete (data) {
      this.SingleObj = data
      this.$refs.SingleDeleteRef.open()
    },
    async handleSingleSuccess () {
      const res = await deleteShoppingCartExchange(this.SingleObj)
      if (res.resultID === 1200) {
        this.$toast(this.$t('操作成功'))
        this.SingleObj = null
      }
      this.getData()
    },
    // 删除
    handleDelete (data) {
      this.delList = data
      this.$refs.promptDialogRef.open()
    },
    // 批量删除
    async handlebatchDel () {
      const data = this.cartList.filter(item => item.checked)
      this.delList = []
      if (!data.length) {
        this.$toast(this.$t('至少選擇壹個商品'))
        return
      }
      await this.handleDelete(data)
    },
    // 全选
    async handleOnAllchecked (blom) {
      if (this.cartList.length) {
        this.cartList.forEach(item => {
          if (item.stock === 0 || item.amount > item.stock) return
          item.checked = blom
        })
        this.getLength()
        this.$store.dispatch("shopCart/setgoodsList", this.cartList)
      }
    },
    // 管理
    handleOnManage () {
      this.isAllDelete = !this.isAllDelete
    },
    async handleSettlement () {
      if (!this.cartList.some(item => item.checked)) {
        this.$toast(this.$t('至少選擇壹個商品'))
        return
      }
      let maingoods = this.cartList.filter(it => it.checked).map(item => {
        return {
          ...item,
          id: item.searchProductId,
          count: item.amount,
          changeProduct: item.changeProduct.length && item.changeProduct.map(item => {
            return {
              ...item,
              tagType: "2"
            }
          })
        }
      })
      let changeProduct = maingoods.filter(it => it.changeProduct.length).flatMap(ite => ite.changeProduct).map(item => {
        return {
          ...item,
          id: item.searchProductId,
          count: item.amount,
        }
      })
      let goods = [...maingoods, ...changeProduct]
      const res = await getProductcreateTempOrder({ goods, isFromShoppingCart: true })
      if (res.resultID !== 1200) {
        this.$toast(res.message)
        if (res.resultID === 1340) {
          this.$refs.promptDialogRef1.open()
          this.message = res.message
        }
        return
      }
      this.$router.push("/order/confirm2")
      // var _this = this
      // var func1 = function () {
      //   mmm.placeOrderList(JSON.stringify(goods))
      // }
      // var func2 = function () {
      //   window.webkit.messageHandlers.placeOrderList.postMessage({ goods: JSON.stringify(goods) })
      // }
      // var func3 = async function () {

      // }

      // this.excFunc(func1, func2, func3)
    }
  }
}
</script>
<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
}

.radio {
  width: 24px;
  height: 24px;
  font-size: 0;
}

.shopCart {
  background: #FFFFFF;
}

.header {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #FFFFFF;
  position: sticky;
  z-index: 1;
  left: 0;
  top: 0;

  .header-left {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #1A1A1A;
    line-height: 24px;
    text-align: left;

    span {
      font-size: 14px;
    }
  }

  .header-right {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 15px;
    color: #1A1A1A;
    line-height: 24px;
    text-align: right;
  }
}

/* 换购 */
.replacement {
  width: 100%;
  background: #F8F8F8;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.replacement-btn {
  // width: 28px;
  padding: 0 3px;
  background: #EC4243;
  border-radius: 4px 4px 4px 4px;
  font-weight: 400;
  font-size: 11px;
  color: #FFFFFF;
  line-height: 14px;
  text-align: center;
}

.replacement-content {
  font-weight: 500;
  font-size: 12px;
  color: #666666;
  line-height: 18px;
  margin-left: 4px;
}

.replacement-right {
  margin-left: 6px;
  font-weight: 400;
  font-size: 12px;
  color: #99CC33;
  line-height: 18px;
}

.replacement-right-other {
  margin-left: 6px;
  font-weight: 400;
  font-size: 12px;
  color: #99CC33;
  line-height: 18px;
}

.main {
  padding-bottom: 200px;
}

.empty {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -40%);
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-items: center;
  font-size: 0;

  img {
    width: 120px;
    height: 120px;
    margin-bottom: 4px;
  }

  .title {
    font-weight: 500;
    font-size: 16px;
    color: #1A1A1A;
    line-height: 24px;
    text-align: center;
    margin-bottom: 4px;
  }

  .txt {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    text-align: center;
    margin-bottom: 24px;
  }

  .empty-btn {
    width: 175px;
    height: 36px;
    background: #90D12E;
    border-radius: 8px 8px 8px 8px;
    font-weight: 500;
    font-size: 15px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
  }
}

.footer {
  position: fixed;
  background: #FFFFFF;
  width: 100%;
  left: 50%;
  bottom: 50px;
  transform: translate(-50%, 0%);

  .shop-coudan {
    height: 46px;
    background: #FFEBE9;
    border-radius: 12px 12px 0px 0px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .shop-coudan-left {
      flex: 1;
      display: flex;
      align-items: center;
    }

    .shop-coudan-right {
      font-weight: 500;
      font-size: 12px;
      color: #E84935;
      line-height: 18px
    }

    .tags {
      padding: 4px 8px;
      box-sizing: border-box;
      font-weight: 500;
      font-size: 11px;
      color: #FFFFFF;
      background: linear-gradient(300deg, #FF7B31 0%, #F9151E 100%), #FF7A00;
      border-radius: 4px 4px 4px 4px;
    }

    .EnTigs {
      font-weight: 500;
      font-size: 12px;
      color: #1A1A1A;
      line-height: 20px;

      span {
        font-weight: 500;
        font-size: 12px;
        color: #E84935;
        line-height: 20px;
      }
    }

    .tigs {
      font-weight: 500;
      font-size: 13px;
      color: #1A1A1A;
      line-height: 20px;
      margin-left: 6px;

      span {
        font-weight: 500;
        font-size: 13px;
        color: #E84935;
        line-height: 20px;
      }
    }
  }

  .footer-bottom {
    padding: 6px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .footer-left {
    display: flex;
    align-items: center;

    .allSelect {
      margin-left: 4px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.9);
      line-height: 20px;
    }
  }

  .footer-right {
    display: flex;
    align-items: center;

    .fee {
      margin-right: 8px;

      .total {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.9);
        line-height: 20px;

        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 800;
          font-size: 16px;
          color: #F82207;
          line-height: 24px;
        }
      }

      .freight {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #666666;
        line-height: 16px;
        text-align: right;
      }
    }

    .settlement {
      width: 101px;
      height: 44px;
      background: #90D12E;
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #FFFFFF;
      line-height: 44px;
      text-align: center;
    }
  }

  .delete-btn {
    width: 101px;
    height: 44px;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #F82207;
    line-height: 44px;
    text-align: center;
    border: 1px solid #F82207;
  }
}
</style>